import type React from 'react'

import type { SubscriptionLink } from '@/store/reducers/subscription'
import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  links: SubscriptionLink[]
}

export const SubscriptionLinks: React.FC<Props> = ({ links }) => (
  <div className={css.subscription_links}>
    {links.map((link) => (
      <a
        key={link.href}
        className={clsJoin(css.link, css[link.type])}
        href={link.href}
        target="_blank"
        rel="noopener"
      >
        {link.label}
      </a>
    ))}
  </div>
)
